import { UserInfo } from '@app/_models/user-info';
import { ReturnUrlStateModel } from './settings.state';

export class UpdateUserInfoAction {
  static readonly type = '[Settings] Set User Info';
  constructor(public payload: UserInfo) { }
}

export class LogoutAction {
  static readonly type = '[Settings] Logout';
}

export class LoginAction {
  static readonly type = '[Settings] Login';
  constructor(public payload: {login: string, password: string} | any) {}
}

export class UpdateReturnUrlAction {
  static readonly type = '[Settings] Set return url';
  constructor(public payload: ReturnUrlStateModel) { }
}
